/**
 * 下单模块
 * @author zhenn
 * @time 2016-11-16
 */
import React, {Component} from 'react';
import OptionList from './option-list';
import channelConfig, { configMap, switchChannelTw } from '../global/channel-config';
import secondList from '../global/second-config';
import Order from '../order/index';
import lang from '../lang/index';
import url from 'c-url';
import native from 'c-up-native';

import SslConfirmModal from './channels/ssl/confirm-modal';
import PaytmNavBar from './channels/paytm/navbar';
import SslNavBar from './channels/ssl/navbar';

let _channel = url.query('channel');

class OrderView extends Component {

    constructor(props) {
        super(props);

        this.channel = url.query('channel');

        if (this.channel == 'twrecharge') {
            switchChannelTw('bank');
            this.state = {
                channel: 'bank',
            };
        } else {
            this.state = {
                select: 0,
                payKey: 'codapay_id_1',
                expand: false,
                expandUser: false
            };
        }
    }

    componentDidMount() {
        let lis = $('.changetype li');

        if (lis.length == 1) {
            lis.css({
                background: 'none',
                color: '#000'
            });
        }
    }

    switchChannel(channel) {
        let curChannel = url.query('channel') || 'paypal';
        if (curChannel == channel) {
            return;
        }

        let target = url.delQuery(location.href, 'channel');
        target = url.addParam(target, {
            channel
        });

        location.replace(target);
    }

    switchChannelTw(channel) {
        switchChannelTw(channel);
        this.setState({
            channel: channel
        });
    }

    /**
     * 切换折叠和显示
     * @param key
     * @param addEvent 是否添加mixpanel打点
     * @returns {Function}
     */
    toggleExpand = (key, addEvent = true) => () => {
        //  处理冲突
        const {expand, expandUser} = this.state;
        
        if (!expand && key === 'expand') {
            // 展开/折叠
            return this.setState({expand: true, expandUser: false});
        }
        if (!expandUser && key === 'expandUser') {
            
            return this.setState({expand: false, expandUser: true});
        }
        const result = this.state[key];
        
        return this.setState({[key]: !result});
    };

    render() {
        let userinfo = this.props.userInfo;
        let channel = this.channel;
        let list = [];
        let { expand } = this.state;
        let $mobileNavbar;

        if (channelConfig.option == 'paypal') {
            channel = 'paypal';
        }

        let $rechargeTypeDom;

        if (channel == 'twrecharge') {

            channel = this.state.channel;

            $rechargeTypeDom = (
                <div className="type twrecharge">
                    <div className={channel == 'bank' ? "bank selected " : "bank"} onClick={() => {
                        this.switchChannelTw('bank')
                    }}>{ configMap.bank.text}</div>
                    <div className={channel == 'mycard' ? "mycard selected " : "mycard"} onClick={() => {
                        this.switchChannelTw('mycard')
                    }}>{ configMap.mycard.text}</div>
                </div>
            );
        }

        let pl = native.getPlatform();
        let isXenopay = channel === 'xenopay';
        let isCashCardThb = channel == 'cashcard_thb';
        // 印度尼西亚充值方式
        let isAlfamartIdr = channel == 'pepay_alfamart_idr';
        let isWebatmIdr = channel == 'pepay_webatm_idr';
        // let isOnlineBankIdr = channel == 'onlinebank_idr';
        let isCodapay = channel === 'codapay';
        let isPaypal = channel === 'paypal';
        let isDokyPay = channel === 'dokypay';
        // let icard = channel === 'icard';
        let isBkAtm = channel === 'bk_atm';

        //  新增的印度的充值方式
        let molpay_points = channel === 'molpay_points';
        // let molpay_credit_card = channel === 'molpay_credit_card';
        let molpay_paytm = channel === 'paytm';
        let isInVip = url.query('channel') === 'invip';

        //  越南的充值方式
        let pepay_onlinebank = channel === 'pepay_onlinebank_vnd';
        let pepay_entitycard = channel === 'pepay_entitycard_vnd';
        //新增印尼、菲律宾、越南充值方式
        let codapay_id;
        let codapay_ph;
        let codapay_vn;
        let codapayList;
        let diff;
        let paypalTips;
        let isGash = channel === 'gash';
        let isGashCard = channel === 'gash_card';
        
        if (channel != null) {
            let urlChannel = channel.split('_');
            codapay_id = urlChannel[0] === 'codapay' && urlChannel[1] === 'id';
            codapay_ph = urlChannel[0] === 'codapay' && urlChannel[1] === 'ph';
            codapay_vn = urlChannel[0] === 'codapay' && urlChannel[1] === 'vn';

            if (isCodapay || codapay_id) {
                codapayList = secondList.codapayIdList
            } else if (codapay_ph) {
                codapayList = secondList.codapayPhList
            } else if (codapay_vn) {
                codapayList = secondList.codapayVnList
            }

            //配置channel
            if (channel == 'codapay' || channel == 'codapay_id') {
                channel = 'codapay_id_1'
            } else if (channel == 'codapay_ph') {
                channel = 'codapay_ph_250'
            } else if (channel == 'codapay_vn') {
                channel = 'codapay_vn_351'
            }
        }

        if (isXenopay) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'xenopay')}
                    className={channel == 'xenopay' ? 'selected' : null}>{lang.template('XenoPay支付')}</li>
            ];
            if (pl == 'wechat') {
                list.push(<li onClick={this.switchChannel.bind(this, 'wechat')}
                              className={channel == 'wechat' ? 'selected' : null}>{lang.template('微信支付')}</li>)
            }
        } else if (isCashCardThb) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'cashcard_thb')}
                    className={channel == 'cashcard_thb' ? 'selected' : null}>{lang.template('CashCard(THB)')}</li>
            ];
        } else if (codapay_id || isCodapay || codapay_ph || codapay_vn) {
            codapayList.map((item, i) => {
                    list.push(<li key={i} onClick={this.switchChannel.bind(this, item, i)}
                                  className={(channel == item) ? 'selected newadd' : 'newadd'}>
                                  {lang.template(configMap[item].text)}</li>)

                }
            )
        } 
        else if (molpay_paytm || isInVip) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'paytm')}
                    className={molpay_paytm ? 'selected' : null}>{lang.template('paytm')}</li>
            ];

            // 只有当被iframe引用时才展执行
            if (window.top !== window.self) {
                list.unshift(<li onClick={this.switchChannel.bind(this, 'invip')} className={isInVip ? 'selected' : null}>{lang.template('VIP充值')}</li>);
            }
        } 
        else if(isAlfamartIdr || isWebatmIdr) {
            // 印度尼西亚充值方式
            list = [
                <li onClick={this.switchChannel.bind(this, 'pepay_alfamart_idr')}
                className={isAlfamartIdr ? 'selected button-col2' : 'button-col2'}>Alfamart</li>,
                <li onClick={this.switchChannel.bind(this, 'pepay_webatm_idr')}
                className={isWebatmIdr ? 'selected button-col2' : 'button-col2'}>Bank Atm</li>
            ];
        } else if (pepay_onlinebank || pepay_entitycard) {
            //  越南的充值方式
            list = [
                <li onClick={this.switchChannel.bind(this, 'pepay_entitycard_vnd')}
                    className={pepay_entitycard ? 'selected button-col2' : 'button-col2'}>{lang.template('pepay_entitycard')}</li>,
                <li onClick={this.switchChannel.bind(this, 'pepay_onlinebank_vnd')}
                    className={pepay_onlinebank ? 'selected button-col2' : 'button-col2'}>{lang.template('pepay_onlinebank')}</li>
            ];
        } else if (isPaypal) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'paypal')}
                    key={channel}
                    className={channel == 'paypal' ? 'selected' : null}>{lang.template('PayPal充值')}</li>,
            ];
        }  else if (isDokyPay) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'dokypay')}
                    key={channel}
                    className={channel == 'paypal' ? 'selected' : null}>{lang.template('DokyPay')}</li>,
            ];
        } else if (isBkAtm){
            list = [
                <li onClick={this.switchChannel.bind(this, 'bk_atm')} className={channel == 'bk_atm' ? 'selected button-col2' : 'button-col2'}  >{lang.template('ATM/Credit Card')}</li>,
            ];
        } else if (channel === 'kakaopay'){
            list = [
                <li key="kakaopay">{lang.template('Kakao pay')}</li>,
            ];
        } else if(channel == 'paystack') {
            list = [
                    <li key={channel}>{ lang.template('paystack') } </li>
            ];
        } else if(channel == 'sslcommerz') {
            list = [
                <li key={channel}>{ lang.template('sslcommerz') } </li>
            ];
        } else if(isGash || isGashCard) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'gash')} className={channel == 'gash' ? 'selected' : null}  >{lang.template('gash')}</li>,
                <li onClick={this.switchChannel.bind(this, 'gash_card')} className={channel == 'gash_card' ? 'selected' : null}  >{lang.template('gash card')}</li>
            ];
        } else if(['codapay_390', 'codapay_391', 'invip'].indexOf(channel) != -1) {
            list = [
                <li onClick={this.switchChannel.bind(this, 'codapay_390')} className={channel == 'codapay_390' ? 'selected newadd' : 'newadd'}  >{lang.template('Paytm Wallet')}</li>,
                <li onClick={this.switchChannel.bind(this, 'codapay_391')} className={channel == 'codapay_391' ? 'selected newadd' : 'newadd'}  >{lang.template('Bank Transfer')}</li>
            ];
            if (window.top !== window.self) {
                list.unshift(<li onClick={this.switchChannel.bind(this, 'invip')} className={isInVip ? 'selected newadd' : 'newadd'}>{lang.template('VIP充值')}</li>);
            }
        } else {
            list = [
                <li onClick={this.switchChannel.bind(this, '')}
                    key="mycard"
                    className={channel == 'mycard' ? 'selected' : null}>{lang.template('MyCard充值')}</li>,
                <li onClick={this.switchChannel.bind(this, 'paypal')}
                    key="paypal"
                    className={channel == 'paypal' ? 'selected' : null}>{lang.template('PayPal充值')}</li>,
                <li onClick={this.switchChannel.bind(this, 'onecard')}
                    key="onecard"
                    className={channel == 'onecard' ? 'selected' : null}>{lang.template('onecard支付')}</li>
            ];
        }
        
        switch(url.query('channel')) {
            case 'twrecharge':
                diff = (
                    <div>
                        <div className="recharge-type">
                            <div className="title">{lang.template('充值方式')}</div>
                            {$rechargeTypeDom}
                        </div>

                        <PayEntry uid={longToString(userinfo.uid)} key={channel}/>
                    </div>
                );
                break;
            // 印度VIP充值
            case 'invip':
                diff = (
                    <div>
                        <div className="changetype">
                            <ul>
                                {list}
                            </ul>
                        </div>

                        <div className="invip">
                            <h5>{lang.template('联系VIP客服进行线下充值，即可享受3%赠钻优惠')}</h5>
                            <ul className="viplist">
                                <li>
                                    <img src="//h.cdn.pengpengla.com/up/uplive-pc/3.2.16/assets/9261c5a728ec358a19b9a87034fc7f9c.png" />
                                    <div className="content">
                                        <p className="nick">Vani Sharma</p>
                                        <p>Wechat ID: Gorav19_</p>
                                        <p>Whatsapp ID: ＋91 8368765271</p>
                                    </div>
                                </li>
                                <li>
                                    <img src="//h.cdn.pengpengla.com/up/uplive-pc/3.2.16/assets/83dcdec06d9d5cc9e05b48673b90f552.png" />
                                    <div className="content">
                                        <p className="nick">Ruchika Tandon</p>
                                        <p>Wechat ID: Ruchikatandon7</p>
                                        <p>Whatsapp ID: ＋91 9650686014</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                );
                break;
            case 'codapay_390':
            case 'codapay_391':
                diff = (
                    <div>
                        <div className="changetype">
                            <ul className='newUL'>
                                {list}
                            </ul>
                        </div>

                        <PayEntry uid={longToString(userinfo.uid)} key={this.state.payKey}/>
                    </div>
                );
                break;
            default:
                diff = (
                    <div>
                        <div className="changetype">
                            <ul className={codapay_id || codapay_ph || isCodapay ? 'newUL' : null}>
                                {list}
                            </ul>
                        </div>

                        <PayEntry uid={longToString(userinfo.uid)} key={this.state.payKey}/>
                    </div>
                );
        }

        if (isInVip) {
            paypalTips = null;
        } else if (!channel || channel == 'paypal') {
            paypalTips = (
                <dl className="paypal-tip">
                    <dt>{lang.template('为了保障您的资金安全，PayPal充值将做以下限制：')}</dt>
                    <dd><em>1.</em> {lang.template('每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；')}</dd>
                    <dd><em>2.</em> {lang.template('若充值过程中出现U钻未到账情况，请在App内联系官方客服；')}</dd>
                </dl>
            );
        }

        if (channel == 'paytm') {
            $mobileNavbar = (<PaytmNavBar expand={ expand } toggleExpand={ this.toggleExpand }/>);
        }

        if (channel == 'sslcommerz') {
            $mobileNavbar = (<SslNavBar expand={ expand } toggleExpand={ this.toggleExpand }/>);
        }

        return (
            <div>
                { $mobileNavbar }
                <div className="userinfo" style={{ paddingTop: channel == 'paytm' ? '1.25rem' : 0}}>
                    {
                        _channel == 'twrecharge' ? (
                            <h6>{lang.template('充值账号：请仔细核对Up账号是否正确，以避免充值错误')}</h6>
                        ) : (<div className="tip">{lang.template('注意：请仔细核对Up号是否正确，避免充值错误。')}</div>)
                    }
                    <div className="box">
                        <div className="base">
                            <img src={userinfo.avatar}/>
                            <div className="content">
                                <h3>{userinfo.username}</h3>
                                <p>{lang.template('Up号')}: {userinfo.upliveCode}</p>
                            </div>
                        </div>

                        {url.query('upcode') ?
                            null :
                            <button className="btn"
                                    onClick={this.props.onChangeAccount}>{lang.template('更换Up号充值')}</button>}
                    </div>
                    {diff}
                    {paypalTips}
                </div>
            </div>
        );
    }
}

let PayEntry = Order(OptionList);

export default OrderView;



// WEBPACK FOOTER //
// ./js/orderview/index.js